import { Box, Center, Text } from "@chakra-ui/react";
import { debounce } from "lodash";
import React, { useEffect, useMemo, useState } from "react";
import { useDropzone } from "react-dropzone";
import { Document, Page } from "react-pdf/dist/esm/entry.webpack";
import { useToast } from "@chakra-ui/react";
import { getWidgetWidth } from "@govisupro/controls";
export const PreviewPlayer = ({ layoutItem, onUpdate, screenWidth, screenHeight, }) => {
    const pdfData = layoutItem.widget.data;
    const updatePdfData = useMemo(() => debounce((pdfData) => onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate(pdfData), 300), [layoutItem, onUpdate]);
    const toast = useToast();
    const [selectedPage, setSelectedPage] = useState(0);
    const [intervalId, setIntervalId] = useState();
    const widgetWidth = getWidgetWidth({
        layoutItemWidth: layoutItem.width,
        screenWidth,
    });
    const widgetHeight = getWidgetWidth({
        layoutItemWidth: layoutItem.height,
        screenWidth: screenHeight,
    });
    const onDrop = (acceptedFiles) => {
        console.log("onDrop AcceptedFiles", acceptedFiles);
        console.log("newPdfData", Object.assign(Object.assign({}, pdfData), { file: acceptedFiles[0] }));
        updatePdfData(Object.assign(Object.assign({}, pdfData), { file: acceptedFiles[0] }));
    };
    const onDropRejected = (fileRejections) => {
        toast({
            status: "error",
            title: "Mauvais format de fichier",
            description: fileRejections[0].errors[0].message,
        });
    };
    const { getRootProps, getInputProps, isDragActive, isDragAccept, isDragReject, } = useDropzone({
        onDrop,
        onDropRejected,
        accept: { "application/pdf": [".pdf"] },
        maxFiles: 1,
    });
    useEffect(() => {
        if (intervalId) {
            clearInterval(intervalId);
        }
        setSelectedPage(1);
        const newIntervalId = setInterval(() => {
            setSelectedPage((selectedPage) => (selectedPage % pdfData.numPages) + 1);
        }, pdfData.pagesTransitionDelay * 1000);
        setIntervalId(newIntervalId);
        return () => {
            clearInterval(intervalId);
        };
    }, [pdfData.file, pdfData.numPages, pdfData.pagesTransitionDelay]);
    const baseStyle = {
        flexShrink: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: 0.75 * widgetWidth,
        height: 0.75 * widgetHeight,
        padding: "20px",
        borderWidth: widgetWidth / 80,
        borderRadius: widgetWidth / 80,
        textAlign: "center",
        fontSize: widgetWidth / 21,
        borderColor: !(isDragAccept || isDragReject)
            ? "#eeeee"
            : isDragAccept
                ? "#00e676"
                : "#ff1744",
        borderStyle: "dashed",
        backgroundColor: "#fafafa",
        color: "#bdbdbd",
        outline: "none",
        transition: "border-color .24s ease-in-out",
        cursor: "pointer",
        userSelect: "none",
    };
    return pdfData.file ? (React.createElement(Document, { file: pdfData.file, onLoadError: (error) => toast({
            status: "error",
            title: error.name,
            description: error.message,
        }), onLoadSuccess: ({ numPages }) => {
            updatePdfData(Object.assign(Object.assign({}, pdfData), { numPages }));
        } },
        React.createElement(Page, { pageNumber: selectedPage, width: widgetWidth, renderMode: "svg" }))) : (React.createElement(Center, { height: widgetHeight },
        React.createElement(Box, Object.assign({}, getRootProps(), { className: "rnd-cancel", style: Object.assign({}, baseStyle) }),
            React.createElement("input", Object.assign({}, getInputProps())),
            isDragActive ? (React.createElement(Text, null, "Glissez les fichiers ici...")) : (React.createElement(Text, null, "Glissez les fichiers ici, ou cliquez pour s\u00E9lectionner un fichier")))));
};
